import React, { useState } from 'react';
import { Navigate, useParams } from 'react-router';

import { faArrowToRight } from '@fortawesome/pro-regular-svg-icons/faArrowToRight';

import { IconLink } from '../../../../common/components/IconLink';
import { Resource } from '../../../../common/constants/resource';
import { WaiveDrawer } from '../../../detail/drawer/waive/WaiveDrawer';

export const WaiveDecision = () => {
  // For controlling the OrderCodebacks drawer
  const [isOpen, setIsOpen] = useState(false);

  const { id } = useParams<{ id: string }>();
  if (id === undefined) {
    return <Navigate to={{ pathname: '/' }} />;
  }

  return (
    <>
      <WaiveDrawer isOpen={isOpen} setIsOpen={setIsOpen} applicationId={id} />
      <IconLink
        onClick={() => setIsOpen(true)}
        icon={faArrowToRight}
        copy={Resource.WAIVE_DECISION}
      />
    </>
  );
};
